import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { FormTextField } from "@covertree/ui";
import { InfoDisclaimerBox } from "@covertree/ui/content";
import type { InsuredTabFormValues } from "@redux/slices/endorsement";

import { SectionCard } from "../../../SectionCard";

interface PropertyAddressProps {
  viewOnly?: boolean;
}

/** Property address section — only Unit / Apt is editable via endorsement. */
export const PropertyAddress = ({ viewOnly = false }: PropertyAddressProps) => {
  const { control } = useFormContext<InsuredTabFormValues>();

  return (
    <SectionCard
      title="Property Address"
      dataTestId="property-address-accordion"
      fieldNames={[
        "propertyCity",
        "propertyState",
        "propertyZipCode",
        "propertyUnitNumber",
        "propertyStreetAddress",
      ]}>
      <Grid container spacing={1.5}>
        <Grid item xs={12}>
          <FormTextField
            disabled
            id="property-street-address"
            name="propertyStreetAddress"
            label="Street address"
            control={control}
            fontSize={18}
            labelFontSize={16}
            dataTestId="property-street-address"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormTextField
            id="property-unit-number"
            name="propertyUnitNumber"
            label="Unit / Apt (optional)"
            control={control}
            fontSize={18}
            labelFontSize={16}
            dataTestId="property-unit-number"
            disabled={viewOnly}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1.5} mt={0}>
        <Grid item xs={12} sm={6} md={5}>
          <FormTextField
            disabled
            id="property-city"
            name="propertyCity"
            label="City"
            control={control}
            fontSize={18}
            labelFontSize={16}
            dataTestId="property-city"
          />
        </Grid>

        <Grid item xs={6} sm={3} md={3}>
          <FormTextField
            disabled
            id="property-state"
            name="propertyState"
            label="State"
            control={control}
            fontSize={18}
            labelFontSize={16}
            dataTestId="property-state"
          />
        </Grid>

        <Grid item xs={6} sm={3} md={4}>
          <FormTextField
            disabled
            id="property-zip-code"
            name="propertyZipCode"
            label="ZIP"
            control={control}
            fontSize={18}
            labelFontSize={16}
            dataTestId="property-zip-code"
          />
        </Grid>
      </Grid>

      <Grid container wrap="nowrap" alignItems="flex-start" gap={1} mt={4}>
        <InfoDisclaimerBox fontSize={14} data-testid="contact-info-box">
          Only Unit / Apt can be changed via endorsement. Changing street, city,
          state, or ZIP requires a cancel &amp; re-write of the policy.
        </InfoDisclaimerBox>
      </Grid>
    </SectionCard>
  );
};
